import Vue from "vue";
import VueRouter from "vue-router";
import App from "./App";
import routes from "./routes/routes";
import axios from "axios";
// import "bootstrap/scss/bootstrap.scss";
// import "bootstrap";
import Select2 from "v-select2-component";
Vue.component("Select2", Select2);
import "vue-search-select/dist/VueSearchSelect.css";
import moment from "moment";
import mixin from "./mixin";

Vue.mixin(mixin);

import VueToastify from "vue-toastify";
Vue.use(VueToastify, {
  position: "top-right",
});

// Vue.filter('formatDate', function(value) {
//     if (value) {
//         return moment.utc(value).format('DD MMM, YYYY hh:mm A')
//     }
// });
Vue.prototype.$filters = {
  formatDate(date) {
    let myDates = Number(date);
    let myDate = new Date(myDates);
    return moment(String(myDate)).format("DD/MM/YYYY hh:mm:ss A");
  },
  formatDateTM(date) {
    let myDates = Number(date);
    let myDate = new Date(myDates);
    return moment(String(myDate)).format("YYYY-MM-DD");
  },
  formatDateTM2(date) {
    let myDates = Number(date);
    let myDate = new Date(myDates);
    return moment(String(myDate)).format("YYYYMMDD");
  },
  formatDateText(date) {
    let myDates = Number(date);
    let myDate = new Date(myDates);
    return moment(String(myDate)).locale("bn-bd").format("dddd, Do MMMM, YYYY");
  },
};

Vue.component("pagination", require("laravel-vue-pagination"));

const router = new VueRouter({
  routes,
  linkActiveClass: "active",
  linkExactActiveClass: "exact-active",
});
if (location.hostname === "localhost") {
  // Vue.prototype.$base = 'http://localhost:8081/#'
  // Vue.prototype.$baseUrl = 'http://localhost:8080/'
  // Vue.prototype.$baseUrl = "https://kabbik.com:8080/";
  Vue.prototype.$baseUrl = 'https://api.kabbik.com/'
} else {
  Vue.prototype.$base = "https://admin.kabbik.com/#";
  // Vue.prototype.$baseUrl = "https://kabbik.com:8080/";
  Vue.prototype.$baseUrl = 'https://api.kabbik.com'
}
Vue.prototype.$publicapi = "https://test.borakexpressbd.com/api/public/";
Vue.prototype.$asset = "https://progga.io/static/";

Vue.prototype.$api = "";
Vue.prototype.$version1 = "/v1";
Vue.prototype.$version2 = "/v2";
Vue.prototype.$version3 = "/v3";
Vue.prototype.$version4 = "/v4";
Vue.prototype.$auth = "/auth";
Vue.prototype.$tokenKey = "token";
Vue.prototype.$idKey = "id";
Vue.prototype.$publisherId = "publisherId";
Vue.prototype.$fullName = "fullName";
Vue.prototype.$profileImage = "profileImage";

import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
Vue.use(VueSweetalert2);

import Multiselect from "vue-multiselect";
Vue.component("multiselect", Multiselect);
import "vue-multiselect/dist/vue-multiselect.min.css";

Vue.prototype.$axios = axios;
Vue.use(VueRouter);

new Vue({
  el: "#app",
  render: (h) => h(App),
  router,
});
